import logger from "../../utils/logger";
import { getSessionUUID } from "../../components/lib/AuthToken";

// functions/drivers_page/drivers_page_account_creation_functions.jsx

export class DriversPageAccountCreationFunctions {

    constructor(showAlert) {
        this.showAlert = showAlert;
    }

    // Submit form to create new account
    async submitForm(data, type, setIsLoading, reset) {
        setIsLoading(true);
        
        // Check passwords match
        if (data.password !== data.confirmPassword) {
            setIsLoading(false);
            this.showAlert({
                message: 'Passwords do not match',
                type: 'danger',
                buttons: [{ label: 'Close' }],
            });
            return;
        }

        try {
            // User input
            const body = {
                firstName: data.firstName,
                surname: type !== 'SERVICE' ? data.surname : null,
                password: data.password,
                email: data.email,
                group: type,
                customer_id: type === 'CUSTOMER' ? data.customer_id : null,
            };

            // Options to send data to backend
            const sessionToken = await getSessionUUID();
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionToken}`,
                },
                body: JSON.stringify(body),
            };

            // Send Request to backend and log any errors
            const response = await fetch('/auth/signup', requestOptions);
            const responseBody = await response.json();

            if (response.status === 201 || response.status === 200) {
                setIsLoading(false);
                this.showAlert({
                    message: responseBody.message || 'Account Created Successfully',
                    type: 'success',
                    buttons: [{ label: 'Close' }],
                });
                
                // Reset the form
                reset();
            } else {
                setIsLoading(false);
                this.showAlert({
                    message: responseBody.error || 'Failed to create account',
                    type: 'danger',
                    buttons: [{ label: 'Retry', type: 'danger' }],
                });
            }
        } catch (error) {
            setIsLoading(false);
            logger.error("Fetch error: ", error);
            this.showAlert({
                message: `Error: ${error.message || 'Error Creating Account!'}`,
                type: 'danger',
                buttons: [{ label: 'Retry', type: 'danger' }],
            });
        }
    }
}
